// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"styles_messageContainer__1BPMp","imageContainer":"styles_imageContainer__ttT4g","confirm":"styles_confirm__1vT0-"};